const FEIFEILI = 'L. Fei-Fei';
const SILVIO = 'Silvio Savarese';
const NIEBLES = 'Juan Carlos Niebles';
const JIAJUNWU = 'Jiajun Wu';

export default [{
  professor: FEIFEILI,
  courses: [
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://cs231n.stanford.edu/',
    event: 'Spring, 2020-21 (Stanford)'
  },
  {
    title: 'CS422: Interactive and Embodied Learning',
    url: 'https://nhaber.github.io/cs422/',
    event: 'Winter, 2020-21 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://cs231n.stanford.edu/',
    event: 'Spring, 2019-20 (Stanford)'
  },
  {
    title: 'CS421/GSBGEN596: Designing AI to Cultivate Human Well-Being',
    url: 'http://designing-ai.stanford.edu/',
    event: 'Winter, 2019-20 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1819/index.html',
    event: 'Fall, 2019-20 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://cs231n.stanford.edu/',
    event: 'Spring, 2018-19 (Stanford)'
  },
  {
    title: 'CS421/GSBGEN596: Designing AI to Cultivate Human Well-Being',
    url: 'http://designing-ai.stanford.edu/',
    event: 'Winter, 2018-19 (Stanford)'
  },
  {
    title: 'CS337/MED277: AI-Assisted Care',
    url: 'http://cs337.stanford.edu/',
    event: 'Fall, Winter, 2018-19 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1819/index.html',
    event: 'Fall, 2018-19 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://vision.stanford.edu/teaching/cs231n/2018',
    event: 'Spring, 2017-18 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1718/index.html',
    event: 'Fall, 2017-18 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://vision.stanford.edu/teaching/cs231n/2017',
    event: 'Spring, 2016-17 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1617/index.html',
    event: 'Fall, 2016-17 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://cs231n.stanford.edu/2016',
    event: 'Winter, 2015-16 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1516/index.html',
    event: 'Fall, 2015-16 (Stanford)'
  },
  {
    title: 'CS231B: The Cutting Edge of Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs231b_spring1415/',
    event: 'Spring, 2014-15 (Stanford)'
  },
  {
    title: 'CS231N: Convolutional Neural Networks for Visual Recognition',
    url: 'http://vision.stanford.edu/teaching/cs231n/2015',
    event: 'Winter, 2014-15 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1415/index.html',
    event: 'Fall, 2014-15 (Stanford)'
  },
  {
    title: 'CS431: High-level Vision: Behaviors, Neurons and Computational Models',
    url: 'http://vision.stanford.edu/teaching/cs431_spring1314/',
    event: 'Spring, 2013-14 (Stanford)'
  },
  {
    title: 'CS331: Advanced Reading in Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs331_winter14/',
    event: 'Winter, 2013-14 (Stanford)'
  },
  {
    title: 'CS131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1314/',
    event: 'Fall, 2014-14 (Stanford)'
  },
  {
    title: 'CS231B: The Cutting Edge of Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs231b_spring1213/',
    event: 'Spring, 2012-13 (Stanford)'
  },
  {
    title: 'CS231A: Introduction to Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs231a_autumn1213/',
    event: 'Autumn, 2012-13 (Stanford)'
  },
  {
    title: 'CS331: Advanced Reading in Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs331_fall12/',
    event: 'Autumn, 2012-13 (Stanford)'
  },
  {
    title: 'CS231A: Introduction to Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs231a_autumn1112/',
    event: 'Autumn, 2011-12 (Stanford)'
  },
  {
    title: 'CS223C: The Cutting Edge of Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs223c_spring1011/',
    event: 'Spring, 2010-11 (Stanford)'
  },
  {
    title: 'CS223B: Introduction to Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs223b/',
    event: 'Winter, 2010-11 (Stanford)'
  },
  {
    title: 'CS423: High-level Vision: Behaviors, Neurons and Computational Models',
    url: 'http://vision.stanford.edu/teaching/cs423_spring0910/',
    event: 'Winter, 2009-10 (Stanford)'
  },
  {
    title: 'CS223B: Introduction to Computer Vision',
    url: 'http://vision.stanford.edu/teaching/cs223b_winter0910/',
    event: 'Spring, 2009-10 (Stanford)'
  },
  {
    title: 'Recognizing and Learning Object Categories: Year 2009',
    url: 'http://people.csail.mit.edu/torralba/shortCourseRLOC/index.html',
    event: 'ICCV 2009 short course'
  },
  {
    title: 'CS323: Recognizing and Learning High-Level Visual Concepts',
    url: 'http://vision.stanford.edu/teaching/cs323_fall09/',
    event: 'Fall, 2009-10 (Stanford)'
  },
  {
    title: 'Summer School in Vision, Learning and Pattern Recognition',
    url: 'http://vision.stanford.edu/VLPR2009/',
    event: 'VLPR 2009 (Beijing)'
  },
  {
    title: 'COS 429: Computer Vision',
    url: 'http://www.cs.princeton.edu/courses/archive/fall08/cos429/',
    event: 'Fall, 2008-09 (Princeton)'
  },
  {
    title: 'COS 598B/PSY 594: From Neuronal Mechanisms to Computational Models',
    url: 'http://www.cs.princeton.edu/courses/archive/spring08/cos598B/',
    event: 'Spring, 2007-09 (Princeton)'
  },
  {
    title: 'COS 429: Computer Vision',
    url: 'http://www.cs.princeton.edu/courses/archive/fall07/cos429/index.html',
    event: 'Fall, 2007-08 (Princeton)'
  },
  {
    title: 'Recognizing and Learning Object Categories: Year 2007',
    url: 'http://people.csail.mit.edu/torralba/shortCourseRLOC/index.html',
    event: 'CVPR 2007 short course'
  },
  {
    title: 'Computer Vision summer school: Object Recognition',
    url: 'http://localhost:4200/documents/Fei-Fei_ICVSS07_ObjectRecognition_web.pdf',
    event: 'ICVSS 2007'
  },
  {
    title: 'COS 598D: High-Level Recognition in Computer Vision',
    url: 'http://vision.stanford.edu/cs598_spring07/',
    event: 'Spring, 2007 (Princeton)'
  },
  {
    title: 'ECE 549: Computer Vision',
    url: 'http://courses.ece.uiuc.edu/ece549/',
    event: 'Fall, 2006-07 (UIUC)'
  },
  {
    title: 'Recognizing and Learning Object Categories',
    url: 'http://people.csail.mit.edu/torralba/shortCourseRLOC/index.html',
    event: 'ICCV 2005 short course'
  },
  {
    title: 'ECE 598FL: Readings in Computer Vision and Learning',
    url: 'http://courses.ece.uiuc.edu/ece598/ffl/',
    event: 'Fall, 2005-06 (UIUC)'
  }]
}, {
  professor: NIEBLES,
  courses: [
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall2021/',
    event: 'Autumn, 2020-21'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1920/',
    event: 'Autumn, 2019-20'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1819/',
    event: 'Autumn, 2018-19'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1718/',
    event: 'Autumn, 2017-18'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1617/',
    event: 'Autumn, 2016-17'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall1516/',
    event: 'Autumn, 2015-16'
  }
  ]
}, {
  professor: SILVIO,
  courses: [
  {
    title: 'CS 331B: Interactive Simulation for Robot Learning',
    url: 'http://cs331b.stanford.edu/',
    event: 'Spring, 2020-21 (Stanford)'
  },
  {
    title: 'CS 231A: Computer Vision: From 3D Reconstruction to Recognition',
    url: 'http://web.stanford.edu/class/cs231a/',
    event: 'Winter, 2020-21 (Stanford)'
  },
  {
    title: 'CS 331B: Representation Learning in Computer Vision',
    url: 'http://web.stanford.edu/class/cs331b/',
    event: 'Autumn, 2017-18 (Stanford)'
  },
  {
    title: 'CS 231A: Computer Vision: From 3D Reconstruction to Recognition',
    url: 'http://web.stanford.edu/class/cs231a/',
    event: 'Winter, 2017-18 (Stanford)'
  },
  {
    title: 'CS 331B: Representation Learning in Computer Vision',
    url: 'http://cs331b.stanford.edu/',
    event: 'Spring, 2016-17 (Stanford)'
  },
  {
    title: 'CS 231A: Mobile Computer Vision',
    url: 'http://cs231a.stanford.edu/',
    event: 'Spring, 2015-16 (Stanford)'
  },
  {
    title: 'CS 231A: Introduction to Computer Vision',
    url: 'http://cvgl.stanford.edu/teaching/cs231a_winter1415/',
    event: 'Winter, 2013-14 (Stanford)'
  },
  {
    title: 'CS 231M: Mobile Computer Vision',
    url: 'http://web.stanford.edu/class/cs231m',
    event: 'Spring, 2013-14 (Stanford)'
  },
  {
    title: 'CS 231A: Introduction to Computer Vision',
    url: 'http://cvgl.stanford.edu/teaching/cs231a_winter1314/',
    event: 'Winter, 2013-14 (Stanford)'
  },
  {
    title: 'CS 331B: Advanced Reading in Computer Vision: 3D Representation and Recognition',
    url: 'http://www.stanford.edu/class/archive/cs/cs331b/cs331b.1142/cgi-bin/mediawiki/index.php/Main_Page',
    event: 'Autumn, 2013-14'
  },
  {
    title: 'EECS 598: Special Topics in Computer Vision',
    url: 'http://www.eecs.umich.edu/courses/eecs598.007',
    event: 'Winter, 2013-14 (Michigan)'
  },
  {
    title: 'EECS 442: Computer Vision',
    url: 'http://www.eecs.umich.edu/vision/teaching/EECS442_2011/eecs442.html',
    event: 'Fall, 2011-12 (Michigan)'
  },
  {
    title: 'EECS 598: Advanced Topics in Mobile Computer Vision',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/EECS598_2010/eecs598.html',
    event: 'Fall, 2010-11 (Michigan)'
  },
  {
    title: 'EECS 442: Computer Vision',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/EECS442_2010/eecs442.html',
    event: 'Fall, 2010-11 (Michigan)'
  },
  {
    title: 'EECS 556: Image Processing',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/EECS556_2009/eecs556.html',
    event: 'Winter, 2010 (Michigan)'
  },
  {
    title: 'EECS 442: Computer Vision',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/EECS442_2009/eecs442.html',
    event: 'Fall, 2009-10 (Michigan)'
  },
  {
    title: 'EECS 598: Special Topics in Computer Vision',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/EECS598/eecs598.html',
    event: 'Winter, 2009-10 (Michigan)'
  },
  {
    title: 'EECS 442: Computer Vision',
    url: 'http://web.eecs.umich.edu/~silvio/teaching/eecs442.html',
    event: 'Fall, 2008-09 (Michigan)'
  }]
}, 
{
  professor: JIAJUNWU,
  courses: [
  {
    title: 'CS 221: Artificial Intelligence: Principles and Techniques',
    url: 'https://stanford-cs221.github.io/winter2021/',
    event: 'Winter, 2020-21 (Stanford)'
  },
  {
    title: 'CS 348I: Computer Graphics in the Era of AI',
    url: 'http://cs348i.stanford.edu/',
    event: 'Autumn, 2020-21 (Stanford)'
  },
  {
    title: 'CS 131: Computer Vision: Foundations and Applications',
    url: 'http://vision.stanford.edu/teaching/cs131_fall2021/',
    event: 'Autumn, 2020-21 (Stanford)'
  },
  ]
}
];
